namespace SorAraBul.Administration {

    @Serenity.Decorators.registerClass()
    export class UserCreditPaymentOrderDialog extends Serenity.EntityDialog<UserCreditPaymentOrderRow, any> {
        protected getFormKey() { return UserCreditPaymentOrderForm.formKey; }
        protected getIdProperty() { return UserCreditPaymentOrderRow.idProperty; }
        protected getLocalTextPrefix() { return UserCreditPaymentOrderRow.localTextPrefix; }
        protected getNameProperty() { return UserCreditPaymentOrderRow.nameProperty; }
        protected getService() { return UserCreditPaymentOrderService.baseUrl; }
        protected getDeletePermission() { return UserCreditPaymentOrderRow.deletePermission; }
        protected getInsertPermission() { return UserCreditPaymentOrderRow.insertPermission; }
        protected getUpdatePermission() { return UserCreditPaymentOrderRow.updatePermission; }

        protected form = new UserCreditPaymentOrderForm(this.idPrefix);

        protected getToolbarButtons() {
            return super.getToolbarButtons().filter(x =>
                x.cssClass !== 'save-and-close-button' &&
                x.cssClass !== 'apply-changes-button' &&
                x.cssClass !== 'delete-button');
        }

        protected updateInterface() {
            super.updateInterface();

            this.deleteButton.hide();
            this.applyChangesButton.hide();
            this.saveAndCloseButton.hide();
        }
    }
}
